import * as React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

function LinkRouter(props) {
  return <Link {...props} component={RouterLink} />;
}

const capitalizeFirstLetter = str => {
  if (typeof str === 'string' && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

/*
  Instructions: Place this component on any page where you'd like the router breadcrumbs (i.e. each portion of the URL separated by /).

  Props:
    - friendlyLinks (optional): an object array of { link, name } or { short, name } entries. Name should represent a human
      readable link (i.e. clientCode rather than clientId by default).
        - link: matches when it equals the full path up to and including the current segment (e.g. '/clients/12').
        - short: matches when it equals the current segment outright (e.g. '/log'), or, as a fallback, when it appears
          anywhere in the path so far. The fallback is skipped under /expenses/ so expense ids are not relabeled.
*/
const RouterBreadcrumbs = ({ friendlyLinks }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  return (
    <Box sx={{ padding: '5px' }}>
      <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon fontSize="small" sx={{ color: 'white !important' }} />}>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const segment = `/${value}`;
          const friendlyLink =
            friendlyLinks &&
            friendlyLinks.find(
              e => e.link === to || (e.short && (e.short === segment || (to.includes(e.short) && !to.includes('/expenses/')))),
            );
          const name = friendlyLink ? friendlyLink.name : capitalizeFirstLetter(value);
          return (
            <LinkRouter variant="h6" underline="hover" color="white" to={to} key={to}>
              {name}
            </LinkRouter>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default RouterBreadcrumbs;
